declare var process: any;

import { merge } from 'lodash';
import * as Cookies from 'js-cookie';
import API from '../api';
import * as actions from '../constants';

const APP_COOKIE = process.env.APP_COOKIE || 'my-auth-cookie';

/**
 * Action to mark a login request as sent
 */
export const requestLogin = (): any => ({
  type: actions.REQUEST_LOGIN,
});

/**
 * Action to mark a login request as rejected
 * @param {String} error
 */
export const rejectLogin = (error): any => ({
  error,
  type: actions.REJECT_LOGIN,
});

/**
 * Action to mark a login response as received
 * @param {String|Boolean} error
 * @param {Object} data
 */
export const receiveLogin = (error, data): any => ({
  error,
  data,
  type: actions.RECEIVE_LOGIN,
});

/**
 * Check the lifetime of the stored cookies
 */
export const checkCookiesLifetime = data => ({
  data,
  type: actions.CHECK_LIFETIME,
});

/**
 * Log in to the system
 * @param {String} email
 * @param {String} password
 * @return {Promise}
 */
export const login = (email, password): any => (
  (dispatch) => {
    dispatch(requestLogin());
    return API.request('/auth/login', 'POST', { email, password })
    .then(response => response.json())
    .then((response) => {
      dispatch(receiveLogin(response.error, response.data));
      if (!response.error) {
        Cookies.set(APP_COOKIE, merge(response.data, {
          date: new Date(),
        }));
      }
      return response;
    })
    .catch(() => {
      dispatch(rejectLogin('Failed to connect to server'));
    });
  }
);

/**
 * Log out of the system
 */
export const logout = (): any => {
  Cookies.remove(APP_COOKIE);
  return {
    type: actions.LOGOUT,
  };
};

/**
 * Validate authentication
 * @return {Promise}
 */
export const validateAuth = (): any => (
  (dispatch) => {
    dispatch({ type: actions.VALIDATE_AUTH });
    dispatch(requestLogin());
    return API.request('/auth')
    .then(response => response.json())
    .then((response) => {
      if (!response.error) {
        dispatch(receiveLogin(false, response.data));
        dispatch(checkCookiesLifetime(response.data));
      } else {
        dispatch(rejectLogin(response.error));
      }
    })
    .catch(() => {
      dispatch(rejectLogin('Failed to connect to server'));
    });
  }
);

/**
 * Switch the current account
 */
export const switchAccount = id => (
  dispatch => dispatch({
    id,
    type: actions.SWITCH_ACCOUNT,
  })
);
